import styled from 'styled-components';

const MainContainer = styled.div`
  background-color: white;
  margin-top: 25px;
  padding: 20px 25px;
  max-width: 376px;
  height: auto;

  .mainTitle {
    width: 100%;
    height: 22px;
    margin: 0 0 20px 0;
    font-size: 16px;
    font-weight: bold;
    color: #2c2c2c;
  }

  .mainComment {
    margin: 40px auto auto auto;
    width: 100%;
    min-height: auto;
  }
  .headComment {
    display: flex;
    width: 100%;
    height: auto;
  }
  .commentSection {
    margin-left: 44px;
  }
  .replyButton {
    width: auto;
    margin-top: 5px;
    margin-left: 36px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8e8e8e;
  }

  .logo {
    height: 50px;
    width: 50px;
  }
  .nameSectionUp {
    display: inline-flex;
    width: inherit;
    min-height: 12px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8e8e8e;
  }
  .userName {
    margin: 0px 45px 0px 5px;
    font-size: 12px;
    min-height: 14px;
    width: 145px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8e8e8e;

    button {
      border: 0;
      margin: 0;
      height: 17px;
      font-size: 12px;
    }
  }

  .commentDate {
    font-size: 12px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #8e8e8e;
  }
  .nameSectionDp {
    width: inherit;
    margin: 0px 0px 0px 2px;
    display: inline-flex;
    height: 20px;
    margin: 2px;
  }
  .projectName {
    width: 230px;
    font-size: 14px;
    font-weight: bold;
    margin: 0px 46px 0px 0px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
  }
  .nameParent {
    width: inherit;
    min-height: 52px;
    margin-left: 6px;
  }
  .commentBox {
    width: 282px;
    min-height: 68px;
    height: auto;
    padding: 8px 9px 8px 12px;
    border-radius: 4px;
    border: solid 1px #eaeaea;
    background-color: #fff;
  }
  .textArea {
    min-height: 41px;
    height: auto;
    margin: auto;
    font-size: 12px;
    overflow-wrap: break-word;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
    span {
      font-weight: unset;
    }
  }
  .iconArea {
    margin-top: 10px;
    width: 124px;
    height: 21px;
  }
  .secondIcon {
    margin-left: 8px;
  }
  ._spectrum-ActionButton-label_7a745 {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8e8e8e;
  }
  .options {
    float: right;
  }

  a {
    text-decoration: none;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
  }
`;

export const RepliesContainer = styled.div`
  margin-left: 48px;
  margin-top: 15px;
  .repliesMainComment {
    width: 100%;
    min-height: 147px;
    margin: auto;
  }
  .repliesHeadComment {
    display: flex;
    width: 100%;
    height: 44px;
  }
  .repliesCommentSection {
    margin-left: 44px;
  }
  .repliesButton {
    width: auto;
    margin-top: 5px;
    margin-left: 36px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8e8e8e;
  }

  .repliesLogo {
    height: 45px;
    width: 45px;
  }
  .repliesNameSectionUp {
    width: inherit;
    height: 12px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8e8e8e;
  }
  .repliesUserName {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8e8e8e;
  }

  .repliesCommentDate {
    margin-top: 3px;
    float: right;
    font-size: 12px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #8e8e8e;
  }
  .repliesNameSectionDp {
    width: inherit;
    height: 20px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
  }
  .repliesNameParent {
    margin-top: 7px;
    width: 83%;
    height: auto;
  }
  .repliesCommentBox {
    width: 235px;
    min-height: 75px;
    height: auto;
    padding: 8px 9px 8px 12px;
    border-radius: 4px;
    border: solid 1px #eaeaea;
    background-color: #fff;
  }
  .repliesTextArea {
    min-height: 41px;
    height: auto;
    margin: auto;
    font-size: 12px;
    overflow-wrap: break-word;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #2c2c2c;
  }
  .repliesIconArea {
    margin-top: 16px;
    width: 124px;
    height: 21px;
  }
  .repliesSecondIcon {
    margin-left: 8px;
  }
`;

export const Label = styled.div`
  font-size: 12px;
  color: #8e8e8e;
`;

export const SubComment = styled.div`
  margin-bottom: 25px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2c2c2c;
`;

export const NoComment = styled.div`
  margin-top: 20px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2c2c2c;
  height: 20px;
`;

export const Avatar = styled.div`
  font-size: 14px;
  height: 35px;
  width: 35px;
  background-color: #8e8e8e;
  color: white;
  border-radius: 50%;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AddCommentContainer = styled.div`
  width: 100%;
  min-height: 200px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 25px;

  .wrapper-class {
    display: flex;
    flex-direction: column-reverse;
  }
  .editor-class {
    overflow: hidden;
    width: 100%;
    height: 76px;
    padding: 0px 0px 1px 8px;
    border-radius: 4px;
    border: solid 1px #eaeaea;
    span{
      font-weight: unset;
    }
  }
}
`;

export const EditorWrap = styled.div`
  padding-bottom: 20px;
`;

export const EditorHeader = styled.div`
  margin-top: 25px;
  margin-bottom: 5px;
  font-size: 12px;
`;

export default MainContainer;
